import { useContext, useState } from 'react'

import classNames from 'classnames'
import {
  CollectionPageContents_collection,
  CollectionSellingMethodType,
} from 'globalTypes'
import TagManager from 'react-gtm-module'

import { Trans } from '@lingui/macro'
import Button from 'Root/App/Button'
import Loader from 'Root/Loader'
import { Context as ContactContext } from 'Root/Pages/Collection/Component/Selling/ContactContext'
import mixpanelTrack from 'lib/mixpanel-track'

import styles from './index.module.css'

interface BuyProps {
  collection: CollectionPageContents_collection
  size?: 'XS' | 'S' | 'M' | 'L'
  customClass?: string
  pagePosition?: 'topbar' | 'price' | 'middle' | 'bottom'
}

const BuyContent = ({ children, isLoading }) => {
  if (isLoading) return <Loader className={styles.loader} />

  return children
}

const Buy = ({
  collection,
  size = 'S',
  customClass,
  pagePosition = 'topbar',
}: BuyProps) => {
  const { slug, title, sellingMethod } = collection
  const { setOpen: setContactOpen } = useContext(ContactContext)
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(false)

  const isContact = sellingMethod === CollectionSellingMethodType.contact

  const handleClickContact = () => {
    setContactOpen(true)
  }

  const handleClickOnline = () => {
    setShowLoadingSpinner(true)

    mixpanelTrack('Click Acquista', {
      id_corso: slug,
      nome_corso: title,
      posizione: pagePosition,
    })

    TagManager.dataLayer({
      dataLayer: {
        event: 'tay_collection_purchase_btn_click',
        collectionSlug: collection?.slug,
        position: pagePosition,
        collectionId: collection?.id,
      },
    })
  }

  if (isContact) {
    return (
      <Button className={customClass} size={size} onClick={handleClickContact}>
        <Trans>Contattami</Trans>
      </Button>
    )
  }

  return (
    <a
      href={`/checkout/cc/${collection.slug}`}
      className={classNames(
        styles[`size-${size.toLowerCase()}`],
        styles.container,
        showLoadingSpinner && 'pointer-events-none opacity-80',
        customClass
      )}
      onClick={handleClickOnline}
    >
      <BuyContent isLoading={showLoadingSpinner}>
        <Trans>Acquista</Trans>
      </BuyContent>
    </a>
  )
}

export default Buy
